import { render, staticRenderFns } from "./FormasPagamento.vue?vue&type=template&id=3dda22ec&scoped=true"
import script from "./FormasPagamento.vue?vue&type=script&lang=js"
export * from "./FormasPagamento.vue?vue&type=script&lang=js"
import style0 from "./FormasPagamento.vue?vue&type=style&index=0&id=3dda22ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dda22ec",
  null
  
)

export default component.exports